import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { updateLocale as fetchUpdateLocale } from '@/api/common';
import { useIsSports } from '@/modules/sports/hooks';
import { useGetCommonStore } from '@/store';

export const useSetupUserLanguage = (currentLang: string) => {
  const useCommonStore = useGetCommonStore();
  const isSports = useIsSports();

  const { userLanguage, pendingUser } = useCommonStore(
    useShallow((s) => ({
      userLanguage: s.user?.language ? s.user.language : s.guestLanguage,
      pendingUser: s.pendingUser,
    }))
  );

  useEffect(() => {
    if (!pendingUser && userLanguage && userLanguage !== currentLang) {
      if (isSports) {
        fetchUpdateLocale({ locale: userLanguage });
        return;
      }
      fetchUpdateLocale({ locale: currentLang });
    }
  }, [userLanguage, currentLang, pendingUser, isSports]);
};
